import { render } from "./LowercaseConverter.vue?vue&type=template&id=3795e987"
import script from "./LowercaseConverter.vue?vue&type=script&lang=js"
export * from "./LowercaseConverter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__